export const alertPaths = {
  root: 'alerts',
  management: 'alerts-management',
};
